import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/lib/custom-validators';
import { AccountService } from 'src/app/services/account.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recover',
  templateUrl: './recover.component.html',
  styleUrls: ['./recover.component.scss']
})
export class RecoverComponent implements OnInit {
  public recoverForm:FormGroup;
  public errorMessages:any=null;
  public complete:boolean=false;

  constructor(
    private _acc: AccountService,
    private router: Router
  ) {
    this.recoverForm = new FormGroup({
      email: new FormControl('',[Validators.required,CustomValidators.validateEmailAddress]),
    });
  }

  recover(){
    this._acc.recoverAccount(this.recoverForm.get('email').value).subscribe(res=>{
      this.complete = true;
    })
  }

  ngOnInit() {
  }

}
